import { useWpOptionsLeftQuery } from '../../../../../../../graphql/react-operations';
import { isNil, toNumber } from 'lodash-es';
import React from 'react';
import { type GqlShareClass, type GqlWarrantParticipant } from '../../../../../../../graphql/base-types.graphql';

/**
 *  @returns the amount of options left for a given share class & participant.
 **/
export const useOptionsLeft = (
  companyId: string,
  warrantProgramId: string,
  shareClassName: GqlShareClass['name'],
  participant?: Pick<GqlWarrantParticipant, 'shareClass' | 'quantity'>,
) => {
  const { data: wpOptions } = useWpOptionsLeftQuery({
    variables: { companyId, input: { id: warrantProgramId, shareClassName } },
    fetchPolicy: 'no-cache',
  });

  return React.useMemo(() => {
    if (isNil(wpOptions?.wpOptionsLeft)) {
      return;
    }
    if (shareClassName === (participant?.shareClass.name ?? 'STAM')) {
      return wpOptions?.wpOptionsLeft + toNumber(participant?.quantity ?? '0');
    }
    return wpOptions?.wpOptionsLeft;
  }, [shareClassName, participant?.shareClass, participant?.quantity, wpOptions?.wpOptionsLeft]);
};
